import posthog from 'posthog-js';

export function initPostHog() {
    posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
        api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
        person_profiles: 'identified_only',
    });
}

export default posthog;
